import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { FormattedMessage, defineMessages } from 'react-intl'
import { QUESTIONS } from 'src/constants/messages'
import { LOAN_TERM_MESSAGES } from 'src/constants/loan'
import { sendRefiRequestForClient } from 'src/actions/refinance'
import { selectContactFirstName } from 'src/store/selectors/contact'
import {
  selectRefiRequested,
  selectRefiRequestSuccess,
  selectRefiRequestFailure
} from 'src/store/selectors/refinance'
import { If } from 'src/Components'
import { IconCommentRight } from 'src/Components/shared/Icon'
import OutreachButton from './OutreachButton'

import styles from './RefiDetailsOutreach.module.scss'

const propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  years: PropTypes.number
}

const messages = defineMessages({
  success: {
    id: 'RefiRequest.success',
    defaultMessage: 'Great! {contactFirstName} will be in {inline}'
  },
  failure: {
    id: 'RefiRequest.failure',
    defaultMessage: 'Request failed, unable to contact {contactFirstName}.'
  }
})

const RefiRequestButton = ({ className, type, years }) => {
  const dispatch = useDispatch()

  const contactFirstName = useSelector(selectContactFirstName)
  const requested = useSelector(selectRefiRequested)
  const success = useSelector(selectRefiRequestSuccess)
  const failure = useSelector(selectRefiRequestFailure)

  const handleClick = useCallback(() => {
    const message = LOAN_TERM_MESSAGES[type.toLowerCase()]
    if (message && message.defaultMessage) {
      const label = message.defaultMessage.replace('{years}', years)
      dispatch(sendRefiRequestForClient(label))
    }
  }, [type, years, dispatch])

  const resultMessage = Object.assign(
    messages[success ? 'success' : 'failure'],
    {
      values: {
        contactFirstName,
        inline: (
          <span className={styles.inline}>
            <FormattedMessage
              id='RefiRequest.success.break'
              defaultMessage='contact shortly.'
            />
          </span>
        )
      }
    }
  )

  return (
    <If condition={type && years}>
      <OutreachButton
        className={className}
        contactFirstName={contactFirstName}
        iconStart={IconCommentRight}
        requested={requested}
        success={success}
        failure={failure}
        buttonMessage={QUESTIONS.refiDetailRate}
        resultMessage={resultMessage}
        handleClick={handleClick}
      />
    </If>
  )
}

RefiRequestButton.propTypes = propTypes

export default RefiRequestButton
